import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { projectDescriptionsByIriSelector } from 'src/selectors/projectDescriptionsByIri';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useUpdateDescriptionForIri = (iri?: string) => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const descriptionsByIri = useReduxSelector(
    projectDescriptionsByIriSelector(projectId)
  );

  return React.useCallback(
    (newDescription: string) => {
      if (!diagram || !iri) {
        return;
      }
      const oldDescription = descriptionsByIri[iri];
      if (newDescription === oldDescription) {
        return;
      }

      commitDiagramModel(diagram, setDescriptionForIri(iri, newDescription));
    },
    [descriptionsByIri, diagram, iri]
  );
};
